import { render, staticRenderFns } from "./LeadsPieChartMultiViewCard.vue?vue&type=template&id=9b0841d2&"
import script from "./LeadsPieChartMultiViewCard.vue?vue&type=script&lang=js&"
export * from "./LeadsPieChartMultiViewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports